const ru: Record<string, string> = {
  'ws.pen': 'Ручка',
  'ws.marker': 'Маркер',
  'ws.eraser': 'Ластик',
  'ws.pan': 'Перемещение',
  'ws.undo': 'Отменить',
  'ws.redo': 'Повторить',
  'ws.zoomIn': 'Увеличить',
  'ws.zoomOut': 'Уменьшить',
  'ws.fit': 'По ширине',
  'ws.template': 'Разлиновка',
  'ws.template.lined': 'В линейку',
  'ws.template.grid': 'В клетку',
  'ws.template.blank': 'Чистый лист',
  'ws.template.exam': 'Экзаменационный бланк',
  'ws.clearPage': 'Очистить страницу',
  'ws.clearConfirmTitle': 'Очистить страницу?',
  'ws.clearConfirmText': 'Все штрихи на этой странице будут удалены. Это можно отменить кнопкой «Отменить».',
  'ws.color': 'Цвет чернил',
  'ws.width': 'Толщина',
  'ws.width.fine': 'Тонкая',
  'ws.width.medium': 'Средняя',
  'ws.width.bold': 'Толстая',
  'ws.page': 'Страница {n}',
  'ws.pageOf': '{n} из {total}',
  'ws.addPage': 'Добавить страницу',
  'ws.deletePage': 'Удалить страницу',
  'ws.deletePageConfirm': 'Удалить эту страницу вместе со штрихами?',
  'ws.movePageUp': 'Переместить раньше',
  'ws.movePageDown': 'Переместить позже',
  'ws.prevPage': 'Предыдущая страница',
  'ws.nextPage': 'Следующая страница',
  'ws.reference': 'Образец',
  'ws.showReference': 'Показать образец',
  'ws.hideReference': 'Скрыть образец',
  'ws.translation': 'Перевод',
  'ws.vocabulary': 'Словарь',
  'ws.prompt': 'Задание',
  'ws.requiredPoints': 'Что нужно упомянуть',
  'ws.wordLimit': '{min}–{max} слов',
  'ws.referenceVersion': 'Версия образца v{v}',
  'ws.submit': 'Сдать на проверку',
  'ws.submitTitle': 'Отправить работу?',
  'ws.submitText': 'После отправки рукопись фиксируется и больше не редактируется. Затем текст будет распознан — вы сможете проверить и исправить распознавание перед оценкой.',
  'ws.submitEmpty': 'На страницах нет ни одного штриха.',
  'ws.submitting': 'Отправляем…',
  'ws.notSynced': 'Дождитесь синхронизации всех страниц (нужна сеть).',
  'ws.sync.synced': 'Синхронизировано',
  'ws.sync.saved_local': 'Сохранено на устройстве',
  'ws.sync.syncing': 'Синхронизация…',
  'ws.sync.offline': 'Офлайн · сохранено на устройстве',
  'ws.sync.conflict': 'Конфликт версий',
  'ws.sync.locked': 'Отправлено — только чтение',
  'ws.sync.error': 'Ошибка синхронизации',
  'ws.conflictTitle': 'Страница изменена на другом устройстве',
  'ws.conflictText': 'На сервере есть более новая версия страницы {n} ({count} штрихов). Выберите, что сохранить. Ничего не будет перезаписано без вашего решения.',
  'ws.conflictMerge': 'Объединить (рекомендуется)',
  'ws.conflictMergeHint': 'Сохранить штрихи с обоих устройств',
  'ws.conflictMine': 'Оставить версию этого устройства',
  'ws.conflictServer': 'Взять версию с сервера',
  'ws.pencilDetected': 'Apple Pencil обнаружен — касания пальцем больше не рисуют. Двумя пальцами — масштаб и прокрутка.',
  'ws.fingerHint': 'Рисуйте пальцем или стилусом. Двумя пальцами — масштаб.',
  'ws.recall.study': 'Прочитайте и запомните текст',
  'ws.recall.studyTimer': 'Осталось {s} с',
  'ws.recall.hide': 'Скрыть образец и писать',
  'ws.recall.hidden': 'Образец скрыт. Напишите текст по памяти.',
  'ws.recall.strict': 'Строгий режим: образец больше не загружается',
  'ws.recall.hints': 'Подсказки',
  'ws.recall.hint.title': 'Заголовок',
  'ws.recall.hint.paragraphStarts': 'Начала абзацев',
  'ws.recall.hint.keywords': 'Ключевые слова',
  'ws.recall.hintUsed': 'Подсказки записываются в результат',
  'ws.free.noPrompt': 'Свободная тема — пишите о чём угодно по-гречески.',
  'ws.drill.title': 'Перепишите правильно',
  'ws.readOnly': 'Работа отправлена — только просмотр',
  'ws.toResults': 'К результатам',
  'ws.canvasLabel': 'Холст для письма, страница {n}',
  'ws.collapseTools': 'Свернуть инструменты',
  'ws.swapSides': 'Поменять образец и тетрадь местами',
  'ws.layoutLeftHanded': 'Раскладка для левши: тетрадь слева, образец справа',
  'ws.layoutRightHanded': 'Раскладка для правши: образец слева, тетрадь справа',
  'ws.expandTools': 'Инструменты',
  'ws.storageWarning': 'Черновик хранится на этом устройстве до синхронизации.',
  'ws.loadingSession': 'Открываем тетрадь…',
  'ws.offlineNew': 'Нет сети — черновик создан на устройстве и синхронизируется позже.',
};
const en: Record<string, string> = {
  'ws.pen': 'Pen',
  'ws.marker': 'Marker',
  'ws.eraser': 'Eraser',
  'ws.pan': 'Move',
  'ws.undo': 'Undo',
  'ws.redo': 'Redo',
  'ws.zoomIn': 'Zoom in',
  'ws.zoomOut': 'Zoom out',
  'ws.fit': 'Fit width',
  'ws.template': 'Ruling',
  'ws.template.lined': 'Lined',
  'ws.template.grid': 'Grid',
  'ws.template.blank': 'Blank',
  'ws.template.exam': 'Exam sheet',
  'ws.clearPage': 'Clear page',
  'ws.clearConfirmTitle': 'Clear this page?',
  'ws.clearConfirmText': 'All strokes on this page will be removed. You can undo this.',
  'ws.color': 'Ink colour',
  'ws.width': 'Width',
  'ws.width.fine': 'Fine',
  'ws.width.medium': 'Medium',
  'ws.width.bold': 'Bold',
  'ws.page': 'Page {n}',
  'ws.pageOf': '{n} of {total}',
  'ws.addPage': 'Add page',
  'ws.deletePage': 'Delete page',
  'ws.deletePageConfirm': 'Delete this page and its strokes?',
  'ws.movePageUp': 'Move earlier',
  'ws.movePageDown': 'Move later',
  'ws.prevPage': 'Previous page',
  'ws.nextPage': 'Next page',
  'ws.reference': 'Model text',
  'ws.showReference': 'Show model',
  'ws.hideReference': 'Hide model',
  'ws.translation': 'Translation',
  'ws.vocabulary': 'Vocabulary',
  'ws.prompt': 'Task',
  'ws.requiredPoints': 'Points to cover',
  'ws.wordLimit': '{min}–{max} words',
  'ws.referenceVersion': 'Model version v{v}',
  'ws.submit': 'Submit for checking',
  'ws.submitTitle': 'Submit this attempt?',
  'ws.submitText': 'After submitting, the handwriting is frozen. The text will then be recognised — you can review and correct it before it is assessed.',
  'ws.submitEmpty': 'There are no strokes on the pages.',
  'ws.submitting': 'Submitting…',
  'ws.notSynced': 'Wait until all pages are synced (needs network).',
  'ws.sync.synced': 'Synced',
  'ws.sync.saved_local': 'Saved on this device',
  'ws.sync.syncing': 'Syncing…',
  'ws.sync.offline': 'Offline · saved on device',
  'ws.sync.conflict': 'Version conflict',
  'ws.sync.locked': 'Submitted — read only',
  'ws.sync.error': 'Sync error',
  'ws.conflictTitle': 'Page changed on another device',
  'ws.conflictText': 'The server has a newer version of page {n} ({count} strokes). Choose what to keep. Nothing is overwritten without your decision.',
  'ws.conflictMerge': 'Merge (recommended)',
  'ws.conflictMergeHint': 'Keep strokes from both devices',
  'ws.conflictMine': 'Keep this device’s version',
  'ws.conflictServer': 'Use the server version',
  'ws.pencilDetected': 'Apple Pencil detected — finger touches no longer draw. Use two fingers to zoom and scroll.',
  'ws.fingerHint': 'Draw with a finger or stylus. Two fingers to zoom.',
  'ws.recall.study': 'Read and memorise the text',
  'ws.recall.studyTimer': '{s} s left',
  'ws.recall.hide': 'Hide model and write',
  'ws.recall.hidden': 'The model is hidden. Write the text from memory.',
  'ws.recall.strict': 'Strict mode: the model is no longer loaded',
  'ws.recall.hints': 'Hints',
  'ws.recall.hint.title': 'Title',
  'ws.recall.hint.paragraphStarts': 'Paragraph starts',
  'ws.recall.hint.keywords': 'Keywords',
  'ws.recall.hintUsed': 'Hints are recorded in the result',
  'ws.free.noPrompt': 'Free topic — write about anything in Greek.',
  'ws.drill.title': 'Rewrite correctly',
  'ws.readOnly': 'Submitted — view only',
  'ws.toResults': 'To results',
  'ws.canvasLabel': 'Writing canvas, page {n}',
  'ws.collapseTools': 'Collapse tools',
  'ws.swapSides': 'Swap model text and notebook',
  'ws.layoutLeftHanded': 'Left-handed layout: notebook left, model right',
  'ws.layoutRightHanded': 'Right-handed layout: model left, notebook right',
  'ws.expandTools': 'Tools',
  'ws.storageWarning': 'The draft is stored on this device until synced.',
  'ws.loadingSession': 'Opening notebook…',
  'ws.offlineNew': 'Offline — the draft was created on this device and will sync later.',
};
export default { ru, en };
